/* @generated */

// src/assets/pictogram/warning.tsx
import * as React from "react";
var WarningPictogram = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M32 41a2 2 0 1 0 2 2 1.856 1.856 0 0 0-2-2Zm-2-13v11.51a4.185 4.185 0 0 1 4 0V28h-4Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M32 9.008 6.531 53h50.938L32 9.008Zm0 7.983 18.531 32.01H13.469L32 16.99Z",
    fill: "currentColor"
  }
));
export {
  WarningPictogram
};
